import React from 'react';
import {ApolloProvider} from 'react-apollo';
import {BrowserRouter, Route} from 'react-router-dom';
import PageContainer from 'containers/PageContainer/PageContainer';

function Root({client, homeRoute, footerData}) {
    return (
        <ApolloProvider client={client}>
            <BrowserRouter>
                <Route
                    path={`${homeRoute}/:slug*`}
                    /* eslint-disable react/jsx-no-bind */
                    render={(props) => (
                        <PageContainer
                            {...props}
                            homeRoute={homeRoute}
                            footerData={footerData}
                        />
                    )}
                />
            </BrowserRouter>
        </ApolloProvider>
    );
}

export default Root;
